import { TradeRow } from '@/components/modules/Blotters/TradeBlotterTable';
import { UseLanguageReturn } from '@/utils/hooks/useLanguage';
import { CellContext, ColumnDef } from '@tanstack/react-table';
import cn from 'classnames';
import { orderStatusColorCell } from './orderBlotterTableHelper';

export const tradeColumns = (lang: UseLanguageReturn, formatQty, generalSettings): ColumnDef<TradeRow>[] => {
    return [
        {
            accessorKey: 'executionTime',
            header: `${lang.blotters.executionTime} (${generalSettings.timezone.value})`,
            size: 130
        },
        { accessorKey: 'orderType', header: lang.blotters.orderType, size: 80 },
        {
            accessorKey: 'status',
            header: lang.blotters.status,
            size: 120,
            cell: (context: CellContext<TradeRow, any>) => {
                const { getValue } = context;
                return <span className={orderStatusColorCell(context)}>{getValue()}</span>;
            }
        },
        { accessorKey: 'type', header: lang.blotters.type, size: 100 },
        { accessorKey: 'instrument', header: lang.blotters.instrument, size: 100 },
        { accessorKey: 'fillPrice', header: lang.blotters.fillPrice, size: 80 },
        { accessorKey: 'avgFillPrice', header: lang.blotters.avgFillPrice, size: 80 },
        {
            accessorKey: 'side',
            header: lang.blotters.side,
            size: 60,
            cell: ({ row, getValue }: CellContext<TradeRow, any>) => {
                const value = getValue();
                return (
                    <div
                        className={cn('text-sm', {
                            'text-brand-green': value === 'BUY',
                            'text-brand-red': value === 'SELL'
                        })}>
                        {value}
                    </div>
                );
            }
        },
        {
            size: 60,
            accessorKey: 'ccy1',
            header: lang.blotters.ccy1,
            cell: ({ row, getValue }: CellContext<TradeRow, any>) => {
                const value = row.original.qty1;
                const ccy = getValue();

                return (
                    <div
                        className={cn('text-sm', {
                            'text-brand-green': value > 0,
                            'text-brand-red': value < 0
                        })}>
                        {ccy}
                    </div>
                );
            }
        },
        {
            size: 80,
            accessorKey: 'qty1',
            header: lang.blotters.qty1,
            cell: ({ row, getValue }: CellContext<TradeRow, any>) => {
                const value = getValue();

                return (
                    <div
                        className={cn('text-sm', {
                            'text-brand-green': value > 0,
                            'text-brand-red': value < 0
                        })}>
                        {isNaN(value) ? '-' : formatQty.format(value)}
                    </div>
                );
            }
        },
        {
            size: 60,
            accessorKey: 'ccy2',
            header: lang.blotters.ccy2,
            cell: ({ row, getValue }: CellContext<TradeRow, any>) => {
                const value = row.original.qty2;
                const ccy = getValue();

                return (
                    <div
                        className={cn('text-sm', {
                            'text-brand-green': value > 0,
                            'text-brand-red': value < 0
                        })}>
                        {ccy}
                    </div>
                );
            }
        },
        {
            size: 80,
            accessorKey: 'qty2',
            header: lang.blotters.qty2,
            cell: ({ row, getValue }: CellContext<TradeRow, any>) => {
                const value = getValue();

                return (
                    <div
                        className={cn('text-sm', {
                            'text-brand-green': value > 0,
                            'text-brand-red': value < 0
                        })}>
                        {isNaN(value) ? '-' : formatQty.format(value)}
                    </div>
                );
            }
        },
        { accessorKey: 'orderId', header: lang.blotters.orderId, size: 160 },
        { accessorKey: 'executionId', header: lang.blotters.executionId, size: 160 },
        { accessorKey: 'fillNo', header: lang.blotters.fillNo, size: 80 },
        { accessorKey: 'account', header: lang.blotters.account, size: 100 },
        { accessorKey: 'user', header: lang.blotters.user, size: 100 }
    ];
};
